import React from 'react'

const Home = () => {
  return (
    <div>
      <h1>Welcome to Product Manager</h1>
<br />

<ul>
    <li>
        Use | to separate or break Line in description.
    </li>
    <li>
        Use **content** to bold the content.
    </li>
</ul>
    </div>
    
  )
}

export default Home
